import { render, staticRenderFns } from "./review.vue?vue&type=template&id=5db66d57&lang=html&"
import script from "./review.vue?vue&type=script&lang=ts&"
export * from "./review.vue?vue&type=script&lang=ts&"
import style0 from "./review.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports